import { FeatureName, ToggleTreatments } from '../../../utils';

import type { UseFeatureHook } from '../../../types';

export const usePetPickyCopy = (useFeature: UseFeatureHook) => {
  const { treatment } = useFeature(FeatureName.CVR_PET_PICKY_COPY);

  return {
    isPetPickyCopyEnabled: treatment === ToggleTreatments.on,
  };
};
